import React from 'react';
import { formatMarketType } from '../utils/oddsUtils';

const PROP_PREFIXES = ['player_', 'batter_', 'pitcher_'];

function MarketBadge({ keytype, playerName }) {
  const marketLabel = formatMarketType(keytype);
  const isProp = playerName && PROP_PREFIXES.some(p => keytype?.startsWith(p));

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: isProp ? '6px 12px' : '5px 10px',
        backgroundColor: 'rgba(0, 217, 255, 0.06)',
        border: '1px solid rgba(0, 217, 255, 0.25)',
        borderRadius: '6px',
        minWidth: '110px',
        maxWidth: '160px',
        gap: '2px'
      }}>
        <span style={{
          fontSize: '11px',
          fontWeight: '700',
          color: '#00d9ff',
          textTransform: 'uppercase',
          letterSpacing: '0.6px',
          whiteSpace: 'nowrap'
        }}>
          {marketLabel}
        </span>
        {isProp && (
          <span style={{
            fontSize: '12px',
            fontWeight: '500',
            color: '#e2e8f0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '150px'
          }}>
            {playerName}
          </span>
        )}
      </div>
    </div>
  );
}

export default MarketBadge;
